// extracted by mini-css-extract-plugin
export var cardIcon = "_5s-4";
export var checkboxCard = "_5s-0";
export var checkboxCardSelected = "_5s-3";
export var disabled = "_5s-1";
export var outerBorder = "_5s-2";
export var spacerMedium = "_5s-7";
export var spacerSmall = "_5s-6";
export var spacerXsmall = "_5s-5";